<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-2">
    <div class="fw-semibold">{{ authFlowTitle$ | async }}</div>
    <div class="subtext">{{ authFlowSubtext$ | async }}</div>
  </div>

  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'email'" i18n>Email</label>
      <app-email-input formControlName="email" controlId="email" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'password'" i18n>New Password</label>
      <app-password-input
        #passwordInput
        formControlName="password"
        controlId="password"
        [error]="formSubmitted && formGroup.controls.password.invalid" />
      <div class="hint-text" i18n>
        Must contain 8+ characters, including 1 number, 1 special character, 1 uppercase letter, and 1 lowercase letter
      </div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.password.invalid"
        [errors]="formGroup.controls.password.errors"
        [customErrorMessages]="customErrorMessages.password" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'confirmPassword'" i18n>Confirm Password</label>
      <app-password-input
        formControlName="confirmPassword"
        controlId="confirmPassword"
        [error]="formSubmitted && formGroup.controls.confirmPassword.invalid"
        (keydown.enter)="setNewPassword()" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.confirmPassword.invalid"
        [errors]="formGroup.controls.confirmPassword.errors"
        [customErrorMessages]="customErrorMessages.confirmPassword" />
    </div>

    <div class="d-flex flex-column gap-1">
      <div class="eula-container">
        <app-checkbox-input formControlName="eulaAccepted" controlId="eulaAccepted" />
        <span class="non-terms-label" i18n>I accept the </span>
        <span (click)="openEulaModal()" class="terms-label" i18n> Terms and Conditions</span>
      </div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.eulaAccepted.invalid"
        [errors]="formGroup.controls.eulaAccepted.errors"
        [customErrorMessages]="customErrorMessages.eulaAccepted" />
    </div>
  </div>

  <app-button class="w-100" [type]="ButtonTypeEnum.primary" (buttonClick)="setNewPassword()" i18n>
    Set New Password
  </app-button>
</div>
